import DetailSPK from './DetailSPK';

export default DetailSPK